import DeletePressItem from "./DeletePressItem";
export default DeletePressItem;
